import { forwardRef, useCallback } from 'react';
import ReactModal from 'react-modal';
import cn from 'classnames';
import { createGenericContext, createBemBlockBuilder } from '@ebsco-ui/utils';
import CloseButton from '@ebsco-ui/close-button';
import { jsxs, jsx } from 'react/jsx-runtime';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _createGenericContext = createGenericContext({
  errorMessage: "Modal compound components cannot be rendered outside the Modal component"
}),
    useModalContext = _createGenericContext.useGenericContext;
    _createGenericContext.GenericContextConsumer;
    var ModalContextProvider = _createGenericContext.GenericContextProvider;

var _excluded$3 = ["children", "className", "closeButtonProps"];

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ModalHeader = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      consumerClassname = _ref.className,
      closeButtonProps = _ref.closeButtonProps,
      rest = _objectWithoutProperties(_ref, _excluded$3);

  var _useModalContext = useModalContext(),
      getBlocksWith = _useModalContext.getBlocksWith;

  return /*#__PURE__*/jsxs("div", _objectSpread$3(_objectSpread$3({
    className: cn(consumerClassname, getBlocksWith("__header")),
    "data-auto": "modal-header",
    ref: ref
  }, rest), {}, {
    children: [/*#__PURE__*/jsx("div", {
      className: getBlocksWith("__header-children"),
      children: children
    }), closeButtonProps && /*#__PURE__*/jsx(CloseButton, _objectSpread$3(_objectSpread$3({}, closeButtonProps), {}, {
      className: cn(closeButtonProps.className, "close-button", getBlocksWith("__close-button")),
      onClick: function onClick(ev) {
        closeButtonProps.onClick && closeButtonProps.onClick(ev);
      }
    }))]
  }));
});

var _excluded$2 = ["children", "className"];

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ModalBody = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded$2);

  var _useModalContext = useModalContext(),
      getBlocksWith = _useModalContext.getBlocksWith;

  return /*#__PURE__*/jsx("div", _objectSpread$2(_objectSpread$2({
    className: cn(className, getBlocksWith("__body")),
    "data-auto": "modal-body",
    ref: ref
  }, rest), {}, {
    children: children
  }));
});

var _excluded$1 = ["children", "className"];

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ModalFooter = forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded$1);

  var _useModalContext = useModalContext(),
      getBlocksWith = _useModalContext.getBlocksWith;

  return /*#__PURE__*/jsx("div", _objectSpread$1(_objectSpread$1({
    className: cn(className, getBlocksWith("__footer")),
    "data-auto": "modal-footer",
    ref: ref
  }, rest), {}, {
    children: children
  }));
});

var _excluded = ["disableAnimations", "appElement", "children", "className", "shouldCloseOnOverlayClick", "isOpen", "onClose", "onAfterClose", "modalTitle", "parentSelector", "toggleButtonRef"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ANIMATION_PROPS;

(function (ANIMATION_PROPS) {
  ANIMATION_PROPS[ANIMATION_PROPS["closeDuration"] = 100] = "closeDuration";
  ANIMATION_PROPS["disableAnimation"] = "disable-animations";
  ANIMATION_PROPS["forwardAnimate"] = "forward-animate";
  ANIMATION_PROPS[ANIMATION_PROPS["openDuration"] = 200] = "openDuration";
  ANIMATION_PROPS["reverseAnimate"] = "reverse-animate";
})(ANIMATION_PROPS || (ANIMATION_PROPS = {}));

var Modal = forwardRef(function (_ref, ref) {
  var _ref$disableAnimation = _ref.disableAnimations,
      disableAnimations = _ref$disableAnimation === void 0 ? false : _ref$disableAnimation,
      _ref$appElement = _ref.appElement,
      appElement = _ref$appElement === void 0 ? "#root" : _ref$appElement,
      children = _ref.children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$shouldCloseOnOve = _ref.shouldCloseOnOverlayClick,
      shouldCloseOnOverlayClick = _ref$shouldCloseOnOve === void 0 ? true : _ref$shouldCloseOnOve,
      isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      consumerOnAfterClose = _ref.onAfterClose,
      modalTitle = _ref.modalTitle,
      _ref$parentSelector = _ref.parentSelector,
      parentSelector = _ref$parentSelector === void 0 ? undefined : _ref$parentSelector,
      toggleButtonRef = _ref.toggleButtonRef,
      rest = _objectWithoutProperties(_ref, _excluded);

  var contentRefCallback = useCallback(function (node) {
    if (ref) {
      if (typeof ref === "function") {
        ref(node);
      } else {
        ref.current = node;
      }
    }
  }, [ref]);
  var baseClassName = "eb-modal";
  var getBlocksWith = createBemBlockBuilder([className, baseClassName]);
  var closeDuration = disableAnimations ? 0 : ANIMATION_PROPS.closeDuration;
  ReactModal.setAppElement(appElement);

  if (appElement === "body") {
    console.error('Applying the aria-hidden="true" attribute to your <body> element hides your entire web page from assistive technology users!');
  }

  var modalContext = {
    getBlocksWith: getBlocksWith,
    onClose: onClose
  };
  return /*#__PURE__*/jsx(ModalContextProvider, {
    value: modalContext,
    children: /*#__PURE__*/jsx(ReactModal, _objectSpread(_objectSpread({
      bodyOpenClassName: getBlocksWith("--open"),
      className: {
        base: cn(getBlocksWith(), disableAnimations && getBlocksWith("--".concat(ANIMATION_PROPS.disableAnimation))),
        afterOpen: cn(getBlocksWith("--".concat(ANIMATION_PROPS.forwardAnimate))),
        beforeClose: cn(getBlocksWith("--".concat(ANIMATION_PROPS.reverseAnimate)))
      },
      closeTimeoutMS: closeDuration,
      contentLabel: modalTitle,
      isOpen: isOpen,
      onRequestClose: onClose,
      overlayClassName: {
        base: cn(getBlocksWith("__overlay"), disableAnimations && getBlocksWith("__overlay--".concat(ANIMATION_PROPS.disableAnimation))),
        afterOpen: getBlocksWith("__overlay--".concat(ANIMATION_PROPS.forwardAnimate)),
        beforeClose: getBlocksWith("__overlay--".concat(ANIMATION_PROPS.reverseAnimate))
      },
      shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
      parentSelector: parentSelector,
      data: {
        auto: "modal"
      },
      contentRef: contentRefCallback,
      onAfterClose: function onAfterClose() {
        toggleButtonRef && toggleButtonRef.current && toggleButtonRef.current.focus();
        typeof consumerOnAfterClose === "function" && consumerOnAfterClose();
      }
    }, rest), {}, {
      children: children
    }))
  });
});
Modal.displayName = "Modal";
Modal.Header = ModalHeader;
Modal.Header.displayName = "Modal.Header";
Modal.Body = ModalBody;
Modal.Body.displayName = "Modal.Body";
Modal.Footer = ModalFooter;
Modal.Footer.displayName = "Modal.Footer";

export { Modal as default };
//# sourceMappingURL=modal-esm.js.map
